module.exports = require("lodash/get");


//////////////////
// WEBPACK FOOTER
// external "lodash/get"
// module id = 97
// module chunks = 0 1 2